module.exports = __webpack_public_path__ + "static/typescript-26cc95f255ccb936d154b43614f61602.png";